import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import ru from 'vuetify/lib/locale/ru';
import iconArrowLeft from '../components/icon-arrow-left';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#1D58F2',
        secondary: '#67697E',
        strokeFourth: '#C4C4C4',
        error: '#CE1E1E',
        success: '#4CAF50',
        textPrimary: '#2C3C4D',
        textSecondary: '#67697E',
        backgroundPrimary: '#F1F1F1',
        fillPrimary: '#FFFFFF'

      }
    }
  },
  icons: {
    values: {
      iconArrowLeft: {
        component: iconArrowLeft // our custom component
      }
    }
  },
  lang: {
    locales: { ru },
    current: 'ru'
  }
});
